<template>
  <div v-if="list" class="flex-1 h-100 border-t border-gray-200 dark:border-gray-800">
    <o-scroll class="h-full p-3">
      <template v-for="day in list" :key="day.date.value">
        <div v-if="day.reservations.length" class="py-3">
          <p class="pl-2 py-2 uppercase opacity-60 text-xs font-medium">
            {{ $date.convert(day.date.value, undefined, $date.presets.long) }}
          </p>
          <reservation
            v-for="reservation in day.reservations"
            :key="reservation.idReservation"
            :data="reservation"
            card-class="rounded-lg border border-gray-200 overflow-hidden relative mb-2 py-3 px-3 bg-gray-50 dark:bg-gray-900 dark:border-gray-800"
          />
        </div>
      </template>
    </o-scroll>
  </div>
</template>

<script setup lang="ts">
import Reservation from './Reservation.vue'

interface Props {
  bookings?: any
}

const props = withDefaults(defineProps<Props>(), {
  bookings: null,
})

const list = computed(() => {
  const bookings = props.bookings
  const dates = bookings?.dates
  const data: any[] = []

  if (dates) {
    for (const item of dates) {
      const { date, label, reservations } = item

      data.push({
        date,
        label,
        reservations: reservations
          ?.sort((a: any, b: any) => {
            return Number(a.startTime?.value) <= Number(b.startTime?.value) ? -1 : 1
          }) || [],
      })
    }
  }

  return data
})
</script>
